/* eslint-disable no-prototype-builtins */
/* eslint-disable no-undef */
// @ts-nocheck
async function install() {
    if (!window.litHydrateSupportInstalled) {
        window.litHydrateSupportInstalled = import(
            '@lit-labs/ssr-client/lit-element-hydrate-support.js'
        );
    }
    await window.litHydrateSupportInstalled;
}
export default install();
